import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { userProducts } from 'src/services/api';
import { PRODUCT_CATEGORY, PRODUCT_REGION } from 'src/constants/product';
import { USER_PRODUCT_STATUS } from 'src/constants/product';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useUser } from 'src/UserContext';
import { KY_BIXBY_NAME, KY_KARAOKE_NAME } from 'src/constants/ky';
import { useModal } from 'src/ModalContext';
import { editEndDateHour } from 'src/services/util';
import { useAppDispatch } from 'src/AppContext';
import useCustomHistory from 'src/hooks/useCustomHistory';
import AutoPaymentCreatedCard from './CreatedCard';
import AutoPaymentActivatedCard from './ActivatedCard';
import AutoPaymentDeactivatedCard from './DeactivatedCard';
import AutoPaymentEmptyCard from './EmptyCard';

dayjs.extend(utc);

const removeCancelled = (products: CheckoutUserProduct[]): CheckoutUserProduct[] => {
  return products.reduce<CheckoutUserProduct[]>((acc, product) => {
    ![USER_PRODUCT_STATUS.SUB_TERMINATED, USER_PRODUCT_STATUS.SUB_CANCELLED].includes(product.status) && acc.push(product);
    return acc;
  }, []);
};

export default function AutoPayment(): JSX.Element {
  const { t } = useTranslation();
  const { isLogin, isInit, userInfo } = useUser();
  const [karaokeList, setKaraokeList] = useState<CheckoutUserProduct[]>([]);
  const [bixbyList, setBixbyList] = useState<CheckoutUserProduct[]>([]);
  const { errorModal } = useModal();
  const history = useCustomHistory();
  const dispatch = useAppDispatch();

  const getKaraokeList = useCallback(() => {
    userProducts({
      searchStartDate: '1970-01-01T00:00:00.000Z',
      category: PRODUCT_CATEGORY.KARAOKE,
      subscription: 'true',
    })
      .then((res) => {
        if (res && res.products && res.products.length > 0) {
          let products = editEndDateHour(res.products);
          products = removeCancelled(products);
          setKaraokeList(products);
        } else {
          setKaraokeList([]);
        }
      })
      .catch(errorModal);
  }, []);

  const getBixbyList = useCallback(() => {
    userProducts({
      searchStartDate: '1970-01-01T00:00:00.000Z',
      category: PRODUCT_CATEGORY.BIXBY,
      subscription: 'true',
    })
      .then((res) => {
        if (res && res.products && res.products.length > 0) {
          let products = editEndDateHour(res.products);
          products = removeCancelled(products);
          setBixbyList(products);
        } else {
          setBixbyList([]);
        }
      })
      .catch(errorModal);
  }, []);
  useEffect(() => {
    if (!isInit) return;
    if (isLogin) {
      getKaraokeList();
      getBixbyList();
    }
  }, [isInit, isLogin]);

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'close' });
    dispatch({
      type: 'SET_GNB_RIGHT_CALLBACK',
      cb: () => {
        history.push('/product/my');
      },
    });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'RESET_GNB_RIGHT_CALLBACK' });
    };
  }, []);
  return (
    <div className="flex flex-col min-h-1/2">
      <div className="w-full">
        <div className="container">
          <div className="N_20_R text-black mt-6 mb-4">{t('product/auto-payment/title')}</div>
        </div>
      </div>
      <div className="bg-light-gray-1 pb-10 flex-grow">
        <div className="container">
          <div className="pt-6">
            <div className="N_14_M">{KY_KARAOKE_NAME}</div>
            {(!karaokeList || karaokeList.length === 0) && <AutoPaymentEmptyCard />}
            {karaokeList &&
              karaokeList.map((obj: CheckoutUserProduct, index: number) => {
                if (obj.status === USER_PRODUCT_STATUS.SUB_ACTIVATED) return <AutoPaymentActivatedCard key={index} obj={obj} />;
                else if (obj.status === USER_PRODUCT_STATUS.SUB_CREATED) return <AutoPaymentCreatedCard key={index} obj={obj} />;
                else if (obj.status === USER_PRODUCT_STATUS.SUB_DEACTIVATED) return <AutoPaymentDeactivatedCard key={index} obj={obj} />;
                // else if (obj.status === USER_PRODUCT_STATUS.SUB_TERMINATED) return <TerminatedCard key={index} obj={obj} />;
                // else if (obj.status === USER_PRODUCT_STATUS.SUB_CANCELLED) return <TerminatedCard key={index} obj={obj} />;
              })}
          </div>
          {userInfo && userInfo.country === PRODUCT_REGION.KR && (
            <div className="pt-6">
              <div className="N_14_M">{KY_BIXBY_NAME}</div>
              {(!bixbyList || bixbyList.length === 0) && <AutoPaymentEmptyCard />}
              {bixbyList &&
                bixbyList.map((obj: CheckoutUserProduct, index: number) => {
                  if (obj.status === USER_PRODUCT_STATUS.SUB_ACTIVATED) return <AutoPaymentActivatedCard key={index} obj={obj} />;
                  else if (obj.status === USER_PRODUCT_STATUS.SUB_CREATED) return <AutoPaymentCreatedCard key={index} obj={obj} />;
                  else if (obj.status === USER_PRODUCT_STATUS.SUB_DEACTIVATED) return <AutoPaymentDeactivatedCard key={index} obj={obj} />;
                  // else if (obj.status === USER_PRODUCT_STATUS.SUB_TERMINATED) return <TerminatedCard key={index} obj={obj} />;
                  // else if (obj.status === USER_PRODUCT_STATUS.SUB_CANCELLED) return <TerminatedCard key={index} obj={obj} />;
                })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
